import { Box, Typography } from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';

export default function ProfileCard() {
  const { user } = useSelector((store) => store.users);

  return (
    <SimpleCard sx={{ padding: '1rem' }}>
      <Box display="flex" alignItems="center" gap={2}>
        <AccountCircle style={{ fontSize: '4rem', color: '#EE7B57' }} />
        <Box>
          <Typography variant="h6" fontWeight="bold">
            {user?.name} {user?.last_name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.email}
          </Typography>
          {user?.phone_number && (
            <Typography variant="body2" color="text.secondary">
              {user?.phone_number}
            </Typography>
          )}
        </Box>
      </Box>
    </SimpleCard>
  );
}
